import { MiniVideoContainer } from "./MiniVideo.styled";
import Stack from "../Utils/Stack.styled";
import Video from "../Video";
import Box from "../Utils/Box.styled";
import {
  ThumbnailImage,
  VideoThumbnail,
} from "../VideoDetails/VideoDetails.styled";
import Button from "../Button";
import CONSTANT from "../../constants/constant";
import { useState } from "react";
import usePlayListStore from "../../stores/playlistStore";
import useQueueStore from "../../stores/queueStore";
import uuid from "react-uuid";
import { useStatus } from "../../contexts/statusContext";
import { usePlaylist } from "../../contexts/playlistContext";

const MiniVideo = ({ videoId, title, thumbnailUrl, children }) => {
  const { setCurrentSelectedVideoDetails } = usePlaylist();
  const { setStatusKey } = useStatus();
  const checkVideoInPlaylist = usePlayListStore(
    (state) => state.checkVideoInPlaylist
  );
  const [newQueueDetails, setNewQueueDetails] = useState();

  const addQueue = useQueueStore((state) => state.addQueue);
  const clearCurrentPlayingPlaylist = usePlayListStore(
    (state) => state.clearCurrentPlayingPlaylist
  );

  const openPlaylistModal = () => {
    checkVideoInPlaylist(videoId);
    setCurrentSelectedVideoDetails({
      videoId: videoId,
      title: title,
      thumbnailUrl: thumbnailUrl,
    });
  };

  const onClickAddToQueue = () => {
    clearCurrentPlayingPlaylist();
    const queue = {
      id: uuid(),
      videoId: videoId,
      title: title,
      thumbnailUrl: thumbnailUrl,
      isPlayingNow: false,
    };
    setNewQueueDetails(queue);
    addQueue(queue);

    setStatusKey(CONSTANT.STATUS_KEY.ADDED_TO_QUEUE);
  };

  return (
    <MiniVideoContainer initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <Stack direction="column" gap="0">
        <Video
          id={newQueueDetails?.id || ""}
          title={title}
          videoId={videoId}
          muted
          radius={0}
        ></Video>
        <Box
          isShadow
          minHeight="100px"
          radius="0px 0px 8px 8px"
          padding="16px 20px"
        >
          <Stack direction="column" gap="16">
            <Stack direction="row" alignItems="center">
              <VideoThumbnail width="40px" height="40px">
                <ThumbnailImage img={thumbnailUrl} />
              </VideoThumbnail>
              {children}
            </Stack>
            <Stack justifyContent="center">
              <Button
                type={CONSTANT.ICON.ADD_TO_PLAYLIST}
                label="Add to playlist"
                onClick={openPlaylistModal}
              />
              <Button
                type={CONSTANT.ICON.ADD_TO_QUEUE}
                label="Add to queue"
                onClick={onClickAddToQueue}
              />
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </MiniVideoContainer>
  );
};

export default MiniVideo;
